import React, { useLayoutEffect, useRef } from 'react'

export interface ShorthandProps {
    link: string
    className?: string
}

const ALLOWED_SHORTHAND_DOMAINS = [
    'stories.thenightly.com.au',
    'stories.thewest.com.au',
    'stories.perthnow.com.au',
    'preview.shorthand.com',
]
export const isShorthand = (link: string) => {
    return ALLOWED_SHORTHAND_DOMAINS.some((domain) => link.includes(domain))
}

export const Shorthand: React.FC<ShorthandProps> = (props) => {
    const ref = useRef<HTMLDivElement | null>(null)

    useLayoutEffect(() => {
        if (ref.current) {
            const script = document.createElement('script')

            let link = props.link
            // remove trailing slash
            if (link.endsWith('/')) {
                link = link.slice(0, -1)
            }
            //remove trailing index.html if it exists
            if (link.endsWith('/index.html')) {
                link = link.replace('/index.html', '')
            }
            // create embed link
            link += '/embed.js'

            script.src = link
            script.async = true

            ref.current.appendChild(script)

            return () => {
                if (window.Shorthand) {
                    window.Shorthand.remove(props.link)
                    //ensure that script has been fully removed and avoid issues with the next page load
                    window.location.reload()
                }
            }
        }
    }, [props.link, ref])

    return <div className={props.className} ref={ref} />
}
